export interface IProjectTransactionGrossComm{
  value:number;
  withoutGst:number;
  gst:number;
  withGst:number;
}
